import {
  WHITELIST_PENDING,
  WHITELIST_STATUS,
} from '../buySellTab.constants';

export const mapWhitelistStatus = (response) => {
  const whitelistStatus = response?.data?.whitelistStatus;
  if (whitelistStatus === 'approved') return WHITELIST_STATUS.APPROVED;
  if (whitelistStatus === 'submitted') return WHITELIST_STATUS.SUBMITTED;
  return WHITELIST_STATUS.NOT_SUBMITTED;
};

export const initialWhitelistUi = {
  pair: {
    status: WHITELIST_STATUS.NOT_SUBMITTED,
    errorMessage: '',
    addressesReady: false,
  },
  wallet: {
    status: null,
    errorMessage: '',
    address: '',
  },
  pending: null,
};

export function whitelistUiReducer(state, action) {
  switch (action.type) {
    case 'reset':
      return initialWhitelistUi;
    case 'wallet_reset':
      return {
        ...state,
        wallet: { status: null, errorMessage: '', address: '' },
        pending: state.pending === WHITELIST_PENDING.FETCH_WALLET ? null : state.pending,
      };
    case 'pair_fetch_start':
      return {
        ...state,
        pending: WHITELIST_PENDING.FETCH_PAIR,
        pair: { ...state.pair, errorMessage: '' },
      };
    case 'pair_fetch_set_status':
      return {
        ...state,
        pending: state.pending === WHITELIST_PENDING.FETCH_PAIR ? null : state.pending,
        pair: {
          status: action.status,
          errorMessage: '',
          addressesReady: true,
        },
      };
    case 'pair_fetch_set_error':
      return {
        ...state,
        pending: null,
        pair: {
          status: WHITELIST_STATUS.NOT_SUBMITTED,
          errorMessage: action.errorMessage || 'Failed to load whitelist status.',
          addressesReady: false,
        },
      };
    case 'pair_fetch_abort':
      return state.pending === WHITELIST_PENDING.FETCH_PAIR
        ? { ...state, pending: null }
        : state;
    case 'wallet_fetch_start':
      return {
        ...state,
        pending: WHITELIST_PENDING.FETCH_WALLET,
        wallet: {
          status: state.wallet.status,
          errorMessage: '',
          address: action.address || state.wallet.address,
        },
      };
    case 'wallet_fetch_set_status':
      return {
        ...state,
        pending: state.pending === WHITELIST_PENDING.FETCH_WALLET ? null : state.pending,
        wallet: {
          status: action.status,
          errorMessage: '',
          address: action.address || state.wallet.address,
        },
      };
    case 'wallet_fetch_set_error':
      return {
        ...state,
        pending: null,
        wallet: {
          status: WHITELIST_STATUS.NOT_SUBMITTED,
          errorMessage: action.errorMessage || 'Failed to load whitelist status.',
          address: action.address || state.wallet.address,
        },
      };
    case 'wallet_fetch_abort':
      return state.pending === WHITELIST_PENDING.FETCH_WALLET
        ? { ...state, pending: null }
        : state;
    case 'subscribe_start':
      return { ...state, pending: WHITELIST_PENDING.SUBSCRIBE };
    case 'subscribe_end':
      return { ...state, pending: null };
    default:
      return state;
  }
}
